<template>
    <div id="container">
        <div id="title">
            <h1>Liste des destinataires</h1>
        </div>
        <div id="content">
            <div class="block-flat-1">
                <b-row>
                    <b-button block v-b-toggle.contactCollapse style="font-size:18px;background:#4B4B4B;"
                        class="text-left title-section mt-3">Contacts supplémentaires
                        <font-awesome-icon icon="caret-down" size="lg"
                            style="float:right;font-size: 26px;color:#fff;" /></b-button>
                    <b-col>
                        <b-collapse id="contactCollapse" visible role="tabpanel">
                            <b-button v-b-modal.add-contact title="Ajouter" variant="info" class="mt-3">
                                <font-awesome-icon v-if="userConnected.roles.includes('ROLE_ADMIN')" icon="plus"
                                    class="mr-1"></font-awesome-icon>
                                Ajouter un destinataire
                            </b-button>
                            <b-modal id="add-contact" title="Ajouter un contact" hide-footer centered>
                                <b-row>
                                    <b-col lg="12" md="12" sm="12" cols="12">
                                        <multiselect placeholder="Sélectionner une commune" v-model="commune"
                                            :options="cities" track-by="id" value-field="id" text-field="name" label="name">
                                        </multiselect>
                                    </b-col>
                                    <b-col lg="12" md="12" sm="12" cols="12">
                                        <b-form-input type="text" name="email" placeholder="Adresse e-mail"
                                            v-model="email"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col lg="6" md="6" sm="6" cols="6" class="text-left">
                                        <b-button variant="danger" @click="$bvModal.hide('add-contact')">Annuler</b-button>
                                    </b-col>
                                    <b-col lg="6" md="6" sm="6" cols="6" class="text-right">
                                        <b-button variant="primary"
                                            @click="$bvModal.hide('add-contact'), addEmailContact(email, commune.id)">Enregistrer</b-button>
                                    </b-col>
                                </b-row>
                            </b-modal>

                            <table class="table-demandes table-users">
                                <header-grid :headers="headers"></header-grid>
                                <tbody>
                                    <tr v-for="contact in contacts" :key="contact.id">
                                        <!-- <td class="text-center">
                                                    <div>
                                                        <label :class="contact.id > 999 ? 'change small-change' : 'change'
                                                            ">
                                                            {{ contact.id }}</label>
                                                    </div>
                                                </td> -->
                                        <td>{{ contact.name }}</td>
                                        <td>{{ contact.email }}</td>
                                        <td class="text-center">
                                            <b-button v-b-tooltip.hover title="Supprimer" variant="danger" class="mr-2"
                                                @click="deleteContact(contact.id)">
                                                <font-awesome-icon v-if="userConnected.roles.includes('ROLE_ADMIN')"
                                                    icon="trash"></font-awesome-icon>
                                            </b-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </b-collapse>
                    </b-col>
                </b-row>
            </div>
            <div class="block-flat-1">
                <b-row>
                    <b-button block v-b-toggle.citiesCollapse style="font-size:18px;background:#4B4B4B;"
                        class="text-left title-section mt-3">Contacts
                        <font-awesome-icon icon="caret-down" size="lg"
                            style="float:right;font-size: 26px;color:#fff;" /></b-button>
                    <b-col>
                        <b-collapse id="citiesCollapse" class="cities-collapse" visible role="tabpanel">
                            <table class="table-demandes table-users mb-3">
                                <header-grid :headers="headersCityNomenclature"></header-grid>
                                <tbody>
                                    <tr v-for="city in cities" :key="city.id">
                                        <!-- <td class="text-center">
                                                    <div>
                                                        <label :class="contact.id > 999 ? 'change small-change' : 'change'
                                                            ">
                                                            {{ contact.id }}</label>
                                                    </div>
                                                </td> -->
                                        <!-- <td>{{ city.name }}</td> -->
                                        <td>{{ city.name }}</td>
                                        <td>{{ city.mailMairie }}</td>
                                        <td>{{ city.mailPM }}</td>
                                        <!-- <td><b-form-input v-model="city.mailMairie"></b-form-input></td> -->
                                        <!-- <td><b-form-input v-model="city.mailPM"></b-form-input></td> -->
                                        <td class="text-center">
                                            <b-button v-b-modal.edit-city @click="getCityById(city.id)" v-b-tooltip.hover
                                                title="Modifier" variant="info" class="mr-2">
                                                <font-awesome-icon v-if="userConnected.roles.includes('ROLE_ADMIN')"
                                                    icon="pen"></font-awesome-icon>
                                            </b-button>
                                        </td>
                                    </tr>
                                    <b-modal id="edit-city" :title="city.name" hide-footer centered>
                                        <b-row>
                                            <b-col lg="12" md="12" sm="12" cols="12">
                                                <b-form-input type="text" name="email" placeholder="Email Mairie"
                                                    v-model="city.mailMairie"></b-form-input>
                                            </b-col>
                                            <b-col lg="12" md="12" sm="12" cols="12">
                                                <b-form-input type="text" name="email" placeholder="Email Police Municipale"
                                                    v-model="city.mailPM"></b-form-input>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col lg="6" md="6" sm="6" cols="6" class="text-left">
                                                <b-button variant="danger"
                                                    @click="$bvModal.hide('edit-city')">Annuler</b-button>
                                            </b-col>
                                            <b-col lg="6" md="6" sm="6" cols="6" class="text-right">
                                                <b-button variant="primary"
                                                    @click="$bvModal.hide('edit-city'), updateCity(city)">Enregistrer</b-button>
                                            </b-col>
                                        </b-row>
                                    </b-modal>
                                </tbody>
                            </table>
                        </b-collapse>
                    </b-col>
                </b-row>
            </div>

            <b-row>
                <b-col cols="12">
                    <div class="pagination">
                        <b-pagination v-model="pagination.current" :total-rows="pagination.totalCount"
                            :per-page="pagination.numItemsPerPage" aria-controls="my-table"></b-pagination>
                    </div>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import Vuex from "vuex";
import Vue from "vue";
import Multiselect from "vue-multiselect";
import headergrid from "../components/HeaderGrid.vue";
import historyMails from "../components/historyMails.vue";
import router from "../router/index.js";
export default {
    name: "Users",
    data: () => ({
        showMails: false,
        showMailsId: null,
        email: null,
        commune: null,
        contactCollapse: true,
        citiesCollapse: false,
        headers: [
            // {
            //     name: "id",
            //     code: "s.id",
            //     width: "70px",
            //     open: false,
            //     sortable: true,
            //     filterable: false,
            //     dir: null,
            //     filter: null,
            //     filterData: null,
            // },
            {
                name: "Commune",
                code: "s.city",
                width: "300px",
                open: false,
                sortable: false,
                filterable: false,
                dir: null,
                filter: null,
                filterData: null,
            },
            {
                name: "Email",
                code: "s.email",
                open: false,
                sortable: false,
                filterable: false,
                dir: null,
                filter: null,
                filterData: null,
            },
            {
                name: "actions",
                width: "110px",
                open: false,
                sortable: false,
                filterable: false,
                dir: null,
                filter: null,
                filterData: null,
            },
        ],
        headersCityNomenclature: [
            {
                name: "Commune",
                code: "s.city",
                width: "300px",
                open: false,
                sortable: false,
                filterable: false,
                dir: null,
                filter: null,
                filterData: null,
            },
            {
                name: "Email Mairie",
                open: false,
                sortable: false,
                filterable: false,
                dir: null,
                filter: null,
                filterData: null,
            },
            {
                name: "Email Police",
                open: false,
                sortable: false,
                filterable: false,
                dir: null,
                filter: null,
                filterData: null,
            },
            {
                name: "actions",
                width: "110px",
                open: false,
                sortable: false,
                filterable: false,
                dir: null,
                filter: null,
                filterData: null,
            },
        ],
        searchText: "",
        searchFilter: [],
        searchDir: "ASC",
        userToRemove: null,
    }),
    watch: {
        "pagination.current": function () {
            this.runSearch();
        },
    },
    components: {
        "header-grid": headergrid,
        "history-mail": historyMails,
        Multiselect
    },
    methods: {
        updateCity(city) {
            this.updateCityNomenclature(city)
        },
        addEmailContact(email, commune) {
            let data = {
                email: email,
                commune: commune
            }
            this.addContact(data)
        },
        deleteContact(id) {
            this.deleteContact(id)
        },
        ...Vuex.mapActions("Contact", ["getContacts", "updateCityNomenclature", "getCityById", "getCities", "addContact", "deleteContact", "setCity"]),
    },
    computed: {
        city: {
            get() {
                return this.city;
            },
            set(value) {
                this.setCity(value);
            },
        },
        ...Vuex.mapGetters("Contact", ["contacts", "cities", "city", "pagination"]),
        ...Vuex.mapGetters("Authentification", ["userConnected"]),
    },
    async mounted() {
        this.getCities();
        this.getContacts();
    },
};
</script>

<style></style>
